/*
 * @Author: 田玉峰
 * @Date: 2020-12-29 11:25:35
 * @LastEditTime: 2020-12-30 10:00:48
 * @LastEditors: Please set LastEditors
 * @Description: 数据页面功用函数
 * @FilePath: /amc/src/views/tenant/dataPage/utils.ts
 */
import { Message } from 'element-ui'
export const clickCopy = (copyStatus: boolean): void => {
  if (copyStatus) {
    Message({
      type: 'success',
      message: '复制成功'
    })
  } else {
    Message({
      type: 'error',
      message: '复制失败'
    })
  }
}
